<template>
  <div class="mt-2 mb-3 ml-3 mr-3">
    <div class="font-weight-medium mb-1">Error</div>
    <div class="mb-3" style="white-space: pre-wrap;">{{ row.errorMessage }}</div>

    <div v-if="loading" class="grey--text">Loading details...</div>

    <div v-if="details && details.errorData" class="font-weight-medium mb-1">
      Error Data
    </div>
    <pre v-if="details && details.errorData" class="portal-error-block mb-3">{{
      details.errorData
    }}</pre>

    <div v-if="details && details.requestBody" class="font-weight-medium mb-1">
      Request Body
    </div>
    <pre v-if="details && details.requestBody" class="portal-error-block mb-3">{{
      details.requestBody
    }}</pre>

    <div v-if="details && details.stackTrace" class="font-weight-medium mb-1">
      Stack Trace
    </div>
    <pre v-if="details && details.stackTrace" class="portal-error-block">{{
      details.stackTrace
    }}</pre>
  </div>
</template>

<script>
export default {
  props: {
    row: Object,
  },
  data() {
    return {
      loading: false,
      details: null,
    };
  },
  created() {
    this.loadDetails();
  },
  methods: {
    async loadDetails() {
      if (!this.row || !this.row.id) return;

      this.loading = true;

      try {
        this.details = await this.$http.get(
          "api/errorLogs/getDetails?id=" + this.row.id
        );
      } catch (e) {
        this.details = null;
      }

      this.loading = false;
    },
  },
};
</script>

<style scoped>
.portal-error-block {
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 320px;
  overflow: auto;
  background: #f5f5f5;
  padding: 8px;
}
</style>
